import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';

import { apiAddressBookFetch } from '..';
import type {
  CategoryNode,
  ContactOwnerAffiliationsRes,
  GetLinkedContactsParams,
  GetLinkedContactsRes,
} from './types';

export const ADDRESS_BOOK_QUERY_KEYS = {
  linkedContacts: 'address-book-linked-contacts',
  categories: 'address-book-categories',
  ownerAffiliations: 'address-book-owner-affiliations',
};

export const _getContactOwnerAffiliations = (contactId: string, scope: string) =>
  queryOptions({
    queryKey: [ADDRESS_BOOK_QUERY_KEYS.ownerAffiliations, contactId, scope],
    queryFn: () =>
      apiAddressBookFetch<ContactOwnerAffiliationsRes>(`/contacts/${contactId}/owner-affiliations`),
    enabled: !!contactId && !!scope,
    retry: 1,
  });

// ==================== Contact Queries ====================

export const LINKED_CONTACTS_PAGE_SIZE = 50;

export const _getLinkedContactsInfinite = (organizationId: string) =>
  infiniteQueryOptions({
    enabled: !!organizationId,
    queryKey: [ADDRESS_BOOK_QUERY_KEYS.linkedContacts, organizationId],
    queryFn: ({ pageParam }) =>
      apiAddressBookFetch<GetLinkedContactsRes>(`/contacts/${organizationId}/linked-contacts`, {
        params: {
          page: pageParam,
          limit: LINKED_CONTACTS_PAGE_SIZE,
        } satisfies GetLinkedContactsParams,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.pagination.page < lastPage.pagination.totalPages
        ? lastPage.pagination.page + 1
        : undefined,
    refetchOnMount: true,
    retry: 1,
  });

// ==================== Category Queries ====================

export const _getCategories = (identity?: string) => {
  return queryOptions({
    queryKey: identity
      ? [ADDRESS_BOOK_QUERY_KEYS.categories, identity]
      : [ADDRESS_BOOK_QUERY_KEYS.categories],
    queryFn: () => apiAddressBookFetch<CategoryNode[]>('/categories'),
    refetchOnMount: true,
    retry: 1,
  });
};

export const _getCategoryById = (id?: string) => {
  return queryOptions({
    enabled: !!id,
    queryKey: [ADDRESS_BOOK_QUERY_KEYS.categories, id],
    queryFn: () => apiAddressBookFetch<CategoryNode>(`/categories/${id}`),
    refetchOnMount: true,
    retry: 1,
  });
};
